// import { isQaOrProdEnv } from '@/shared/constants/env';

import { Toaster } from '@crehana/compass.ui/toaster';
import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

import {
  CommonLayouts,
  Devtools,
  // FacebookPixel,
  // GoogleScripts,
  // PreconnectResources,
  // PreloadResources,
} from './components';
import { addMicrofrontendNameToWindows } from './utils/addMicrofrontendNameToWindows';

type TRootLayoutProps = {
  children: React.ReactNode;
};

addMicrofrontendNameToWindows();

export function RootLayout({ children }: TRootLayoutProps) {
  return (
    <>
      {/* {isQaOrProdEnv ? (
        <>
          <PreconnectResources />
          <PreloadResources />
          <noscript>
            Google Tag Manager (noscript) eslint-disable-next-line
            jsx-a11y/iframe-has-title
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_ID}`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            />
            End Google Tag Manager (noscript)
          </noscript>
          <noscript>
            <img
              alt="noscript-fbpixel"
              height="1"
              width="1"
              style={{ display: 'none' }}
              src={`https://www.facebook.com/tr?id=${process.env.NEXT_PUBLIC_FB_PIXEL_ID}&ev=PageView&noscript=1`}
            />
          </noscript>
        </>
      ) : null} */}
      {/* force inline this class names */}
      <span
        className="cui-is-visible cui-is-hidden"
        style={{
          opacity: 0,
          visibility: 'hidden',
          height: 0,
          width: 0,
          position: 'absolute',
        }}
        aria-hidden
      />
      <Toaster />
      <CommonLayouts>
        {children}
        <HanaFloatingChatLazy />
      </CommonLayouts>
      {/* {isQaOrProdEnv && (
        <>
          <FacebookPixel />
          <GoogleScripts />
        </>
      )} */}
      <Devtools />
    </>
  );
}
